/** contentEditable 内联 mention 类型 */
export type TMentionEditorKind = 'knowledge' | 'skill';

export interface IInsertMentionOptions {
  usePinnedOffset?: boolean;
  knowledgeItems?: import('../KnowledgeBaseMention/components/SelectedKnowledgeTag').ISelectedKnowledgeTagData[];
  skillPayload?: import('../SkillMention/SelectedSkillTag').ISelectedSkillTagData;
}

/** 与 textarea 兼容的编辑器表面 API，供 mention host 复用 */
export interface IMentionEditorSurface {
  value: string;
  selectionStart: number;
  selectionEnd: number;
  focus: () => void;
  setSelectionRange: (start: number, end: number) => void;
  getRootElement: () => HTMLElement | null;
  insertMentionAtTrigger: (
    triggerIndex: number,
    body: string,
    kind: TMentionEditorKind,
    mentionKey: string,
    triggerChar?: string,
    options?: IInsertMentionOptions,
  ) => void;
  replaceMentionBody: (
    oldBody: string,
    newBody: string,
    kind: TMentionEditorKind,
    options?: Pick<IInsertMentionOptions, 'knowledgeItems'>,
  ) => void;
  insertMentionAtSelection: (
    body: string,
    kind: TMentionEditorKind,
    mentionKey: string,
    options?: IInsertMentionOptions,
  ) => void;
  insertAtSelection: (text: string) => void;
  saveSelection: () => void;
  getPanelInsertOffset: () => number | null;
  clearPanelInsertOffset: () => void;
  relocalizeMentions: () => void;
  /** 知识库按钮模式关面板：批量重建 mention，仅触发一次 onChange */
  syncKnowledgeMentionTags: (
    groups: import('../KnowledgeBaseMention/components/SelectedKnowledgeTag').ISelectedKnowledgeTagData[][],
  ) => void;
  /** 强制清空编辑器 DOM（新建对话 / 发送后清空，绕过 hydrate 守卫） */
  resetEditor: () => void;
  /** 父级 value 未变时仍从序列化串重建 DOM（@button 关面板） */
  forceHydrateFromValue: (
    text: string,
    knowledgeItems?: import('../KnowledgeBaseMention/components/SelectedKnowledgeTag').ISelectedKnowledgeTagData[],
    options?: { cursorAtEnd?: boolean; },
  ) => void;
}

export const isMentionEditorSurface = (
  el: unknown,
): el is IMentionEditorSurface =>
  Boolean(
    el
    && typeof el === 'object'
    && 'getRootElement' in (el as object)
    && 'insertMentionAtTrigger' in (el as object),
  );
